import fetch from '@/utils/fetch';
import { message } from 'antd';
import { ListProps, IPostComplaintDetailArgs, ShopInfo, ComplaintDetail, ILogData } from './type';
import { cloneDeep } from 'lodash';
import filterNull from '@/utils/filterNull';

const model = {
  state: {
    ComplaintList: [] as ListProps[],
    ComplaintListTotal: 0,
    expandedRowKeysList: [],
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { Complaint, basic }, getState }) => ({
    setInitChildList(list: ListProps[]) {
      const newList = list.map((item, index) => {
        item.keyId = String(index);
        if (item.hasChild) {
          item.children = [];
        }
        return item;
      });
      return newList;
    },
    async getComplaintList(params) {
      const res = await fetch('/saasmerchant/web/complaint/config/page', {
        type: 'GET',
        params,
      });
      if (res) {
        const resList = Complaint.setInitChildList(res.list || []);
        Complaint.setState({ ComplaintList: resList });
        Complaint.setState({ ComplaintListTotal: res.total });
      }
      return res;
    },
    async getChildComConfigList(parentId: number, complaintType?: number) {
      const list = await fetch('/saasmerchant/web/complaint/config/list', {
        type: 'GET',
        params: filterNull({
          parentId,
          complaintType,
        }),
      });
      return list || [];
    },
    async getChildComplaintList(expanded: boolean, params: ListProps, complaintType?: number) {
      if (!expanded) return;
      const { ComplaintList } = getState().Complaint;
      const parentId = params.configId || 0;
      const { keyId } = params;
      const res = await Complaint.getChildComConfigList(parentId, complaintType);
      if (res) {
        const childList = res.map((item, index) => {
          item.keyId = `${keyId}-${index}`;
          if (item.hasChild) {
            item.children = [];
          }
          return item;
        });
        const keyIds = keyId.split('-');
        const cloneComplaintList = cloneDeep(ComplaintList);
        const target = keyIds.reduce((obj, key, index) => {
          if (index === keyIds.length - 1) {
            return obj[key];
          }
          return obj[key].children;
        }, cloneComplaintList);
        target && (target.children = childList);
        Complaint.setState({ ComplaintList: cloneComplaintList });
      }
    },

    async getConfigDetail(configId: number) {
      const detail = await fetch('/saasmerchant/web/complaint/config/detail', {
        type: 'GET',
        params: {
          configId,
        },
      });
      return detail;
    },
    async createComplaintConfig(params) {
      const data = await fetch('/saasmerchant/web/complaint/config/create', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    async updateComplaintConfig(params) {
      const data = await fetch('/saasmerchant/web/complaint/config/update', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    async deleteComplaintConfig(configId: number) {
      const data = await fetch('/saasmerchant/web/complaint/config/delete', {
        type: 'GET',
        params: {
          configId,
        },
      });
      return data;
    },
    async exportComplaintList(params) {
      const data = await fetch('/saasmerchant/web/complaint/detail/export', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        basic.setLogListDot(true);
        message.success('成功添加导出任务');
      }
      return data;
    },
    async getComplaintDetail(recordId: number) {
      const data = await fetch('/saasmerchant/web/complaint/detail/get', {
        type: 'GET',
        params: {
          recordId,
        },
      });
      return data || {};
    },

    async postComplaintDetail(params: IPostComplaintDetailArgs) {
      const data = await fetch('/saasmerchant/web/complaint/detail/handle', {
        type: 'POST',
        useJson: true,
        params,
      });
      return data;
    },
    async getShopList(subShopName: string) {
      const detail: ShopInfo[] = await fetch(
        '/saasmerchant/web/bms/shop/getSubShopPartListLimitByName',
        {
          params: {
            shopName: subShopName,
          },
        },
      );
      return detail;
    },
    async getSubShopDetail(orderId: string) {
      const detail: ShopInfo = await fetch('/saasmerchant/web/order/querydetail', {
        params: {
          orderId,
        },
      });
      return detail;
    },
    async addComplaintDetail(params: ComplaintDetail) {
      const data = await fetch('/saasmerchant/web/complaint/detail/add', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      return data;
    },
    async getOprateLogList(params: { id: number; page: number; pageSize: number }) {
      const data = await fetch('/saasmerchant/web/complaint/detail/log', {
        type: 'GET',
        params,
      });
      return data || {};
    },
  }),
};

export default model;
